module.exports = __webpack_public_path__ + "img/wma.9320a39c.png";